// extracted by css-extract-rspack-plugin
export default {"header":"v1v3nSyYBHApRrrU","content":"jHtD4_yScWOwd9CT","actions":"r0XSDuGUnktNYR4A"};